import { render, staticRenderFns } from "./UnreadSeparator.vue?vue&type=template&id=3f58bf72&scoped=true"
import script from "./UnreadSeparator.vue?vue&type=script&lang=js"
export * from "./UnreadSeparator.vue?vue&type=script&lang=js"
import style0 from "./UnreadSeparator.vue?vue&type=style&index=0&id=3f58bf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58bf72",
  null
  
)

export default component.exports